module.exports = __webpack_public_path__ + "static/media/logout-color.89187c91.svg";